import component from './invoiceModal.component';

let module = angular.module('invoiceModal', [])
	.component('invoiceModal', component)
	.name;

export default module;



// WEBPACK FOOTER //
// ./app/components/invoiceModal/invoiceModal.js